import styled, { keyframes, css } from "styled-components/macro";

const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px; /* space between spinner and text */

  &.loading-spinner {
    flex-direction: row;
  }
`;

export const SpinnerCircle = styled.div`
  width: ${(props) => props.size || 24}px;
  height: ${(props) => props.size || 24}px;
  border: 2px solid ${(props) => props.color || "#fff"};
  border-left-color: transparent;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const LoadingText = styled.span`
  font-size: ${(props) => props.fontSize || 14}px;
  color: ${(props) => props.color || ""};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.016px;
`;

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const SkeletonBlock = styled.div`
  background-color: #f0eeeeff;
  background-image: linear-gradient(
    90deg,
    #f0eeeeff 0px,
    #f4f4f4 40px,
    #f0eeeeff 80px
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  display: inline-block;
  margin: 0;
  animation: ${shimmer} 1.2s ease-in-out infinite;
  ${({ height, width, borderRadius }) => css`
    height: ${height};
    width: ${width};
    border-radius: ${borderRadius};
  `}
  ${({ variant, height }) =>
    variant === "circle" &&
    css`
      width: ${height};
      border-radius: 50%;
    `}
`;
